import { withSseAccessToken } from '@signals/app-shell/utils/sseAuthUrl';

export interface PttUtterance {
  id: number;
  device_id: string;
  entity_id?: string | null;
  course_id?: string | null;
  channel_id: string;
  started_at: string;
  ended_at: string;
  latitude?: number | null;
  longitude?: number | null;
  transcript?: string | null;
  transcript_source?: string;
  confidence?: number | null;
  team?: string | null;
  sender?: string | null;
}

class PttService {
  private baseUrl = '/api/ptt';

  private get authHeaders(): Record<string, string> {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access_token') || ''}`,
    };
  }

  async listUtterances(params: {
    entity_id?: string;
    device_id?: string;
    channel?: string;
    course_id?: string;
    start?: string;
    end?: string;
    q?: string;
    limit?: number;
  }): Promise<{ utterances: PttUtterance[]; count: number }> {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.set(key, String(value));
      }
    });
    const res = await fetch(`${this.baseUrl}/utterances?${search}`, {
      headers: this.authHeaders,
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  }

  connectStream(
    onUtterance: (u: PttUtterance) => void,
    channel?: string,
  ): EventSource {
    const qs = channel ? `?channel=${encodeURIComponent(channel)}` : '';
    const url = withSseAccessToken(`${this.baseUrl}/stream${qs}`);
    const es = new EventSource(url);
    es.addEventListener('utterance', (ev: MessageEvent) => {
      try {
        onUtterance(JSON.parse(ev.data));
      } catch {
        /* ignore malformed */
      }
    });
    return es;
  }
}

export const pttService = new PttService();
